module.exports = __webpack_public_path__ + "static/SquareSerif-Demi-webfont-6ec5b88769b661236c6d799207c90223.woff2";